import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${BACKEND_URL}/api/payments/status/${sessionId}`);
      
      if (response.data.payment_status === 'paid') {
        setStatus('success');
      } else {
        setStatus('pending');
        // Poll again after 2 seconds
        setTimeout(checkPaymentStatus, 2000);
      }
    } catch (error) {
      console.error('Error checking payment:', error);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-8 text-center">
        {status === 'checking' || status === 'pending' ? (
          <>
            <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold mb-2">Verificando Pago...</h2>
            <p className="text-slate-600">Por favor espera mientras confirmamos tu pago</p>
          </>
        ) : status === 'success' ? (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Pago Exitoso</h2>
            <p className="text-slate-600 mb-6">
              Tu pago ha sido procesado correctamente. El servicio ha sido registrado en tu Car Passport.
            </p>
            <Button onClick={() => navigate('/client/dashboard')} className="w-full">
              Volver al Dashboard
            </Button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">!</span>
            </div>
            <h2 className="text-2xl font-bold mb-2">Error al Verificar</h2>
            <p className="text-slate-600 mb-6">
              Hubo un problema al verificar tu pago. Por favor contáctanos.
            </p>
            <Button onClick={() => navigate('/client/dashboard')} variant="outline" className="w-full">
              Volver al Dashboard
            </Button>
          </>
        )}
      </Card>
    </div>
  );
};

export default PaymentSuccess;